import i18next from 'i18next';
import { isDate } from 'lodash';

const MONTHS_KEYS = [
  'january',
  'february',
  'march',
  'april',
  'may',
  'june',
  'july',
  'august',
  'september',
  'october',
  'november',
  'december',
];

const withLeadingZero = (n: number | string) => (parseInt('' + n) < 10 ? '0' + n : '' + n);

export const dateFormat = (date: Date | string, format: string = 'D.M.Y') => {
  const dateValues = new Date(date);

  // console.log(date);

  if (!isDate(dateValues)) return date;

  const d = {
    date: dateValues.getDate(),
    month: dateValues.getMonth(),
    year: dateValues.getFullYear(),
    minutes: withLeadingZero(dateValues.getMinutes()),
    hours: withLeadingZero(dateValues.getHours()),
  };

  const replaceObject: any = {
    d: d.date,
    D: withLeadingZero(d.date),
    m: d.month + 1,
    M: withLeadingZero(d.month + 1),
    F: i18next.t(MONTHS_KEYS[d.month]),
    Y: d.year,
    T: `${d.hours}:${d.minutes}`,
  };

  return format.replace(/[dDmMFYT]/g, (o) => replaceObject[o]);
};

// convert D.M.Y format to M-D-Y
export const DMYtoMDY = (x: string) => {
  const v = x.split('.');
  return [v[1], v[0], v[2]].join('.');
};
